module.exports = __webpack_public_path__ + "img/exemploColunas.4f799b22.png";